module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-card"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Waterfall")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }, {
      name: "waterfall-upper",
      rawName: "v-waterfall-upper",
      value: (_vm.loadMoreUpper),
      expression: "loadMoreUpper"
    }],
    attrs: {
      "waterfall-disabled": "isWaterfallDisabled",
      "waterfall-offset": "400"
    }
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "zan-cell",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("loading")])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-726870b2!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/waterfall.vue
// module id = 252
// module chunks = 0